/**
 * Bucket ids must exist in Supabase Storage (see supabase/migrations/007_rename_to_ggj_b2b.sql
 * and supabase/create_b2b_storage_buckets.sql). Override via env if your project uses other names.
 */
export const B2B_CANDIDATE_RESUME_BUCKET =
  import.meta.env.VITE_SUPABASE_STORAGE_BUCKET_CANDIDATE_RESUMES?.trim() || 'ggj_b2b-candidate-resumes';

/** Client onboarding / compliance uploads (CLI-051). */
export const B2B_CLIENT_COMPLIANCE_BUCKET =
  import.meta.env.VITE_SUPABASE_STORAGE_BUCKET_CLIENT_COMPLIANCE?.trim() || 'ggj_b2b-attachments';
